"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7403],{

/***/ 69658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModernMiddleBody2_ModernMiddleBody2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(92578);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Description/Description.js
var Description = __webpack_require__(58252);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(26601);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(20901);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Tabs/ModernMiddleBody2/ModernMiddleBody2.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0; /* Set the z-index behind other content */\n  }\n  /* Add a linear gradient overlay */\n  &::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    opacity: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  & > video {\n    position: absolute;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 768px) {\n    padding: 4rem;\n    gap: 4rem;\n  }\n  @media screen and (max-width: 767px) {\n    padding: 2rem 0rem;\n    gap: 2.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  @media screen and (min-width: 768px) {\n    gap: 4rem;\n  }\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  & > h1 {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: ",
        ";\n  }\n  & > p {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    font-style: normal;\n    color: ",
        ";\n    text-align: ",
        ";\n    font-family: ",
        ";\n    opacity: ",
        ";\n    margin: 0;\n  }\n  @media screen and (min-width: 768px) {\n    & > h1 {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 3.875rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n    & > p {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 1.75rem;\n      align-self: flex-start;\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > h1 {\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: normal;\n      width: 100%;\n      align-self: center;\n    }\n    & > p {\n      font-size: 0.875rem;\n      font-weight: 400;\n      line-height: normal;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* min-width: max-content; */\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: 768px) {\n    align-self: center;\n  }\n  @media screen and (max-width: 767px) {\n    align-self: flex-start;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n  @media screen and (max-width: 767px) {\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  overflow-x: auto;\n  border-bottom: ",
        ";\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  & div {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n  & div > .nav-link-text {\n    flex: 0;\n    width: 100%;\n    padding: 0.875rem 1rem;\n    min-width: fit-content;\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n    cursor: pointer;\n    overflow-y: hidden;\n  }\n  & .nav-link-text > .bar {\n    position: absolute;\n    border: 2.5px solid ",
        ";\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    bottom: -2px;\n    right: 0;\n    width: 100%;\n  }\n  & .nav-link-text > .bar.hidden {\n    display: none;\n  }\n  & .nav-link-text > .bar.active {\n    display: block;\n  }\n  @media screen and (max-width: 767px) {\n    & div {\n      justify-content: flex-start;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .modern_theme_middlebody3 {\n    padding: 0 1rem !important;\n    background: transparent !important;\n  }\n  & .modern_theme_middlebody3 > div {\n    align-self: center;\n  }\n  & .modern_theme_middlebody3 .heading {\n    font-size: 2.5rem !important;\n  }\n  & .modern_theme_middlebody3 > div > div:first-child {\n    padding: 0rem !important;\n  }\n  @media screen and (min-width: 768px) {\n    & .modern_theme_middlebody3 > div {\n      gap: 2.5rem !important;\n    }\n    & .modern_theme_middlebody3 > div > div:first-child {\n      gap: 1.5rem !important;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & .modern_theme_middlebody3 > div {\n      gap: 1rem !important;\n    }\n    & .modern_theme_middlebody3 > div > div:first-child {\n      gap: 1rem !important;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var MiddleBodyVideoBackground = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    var ref, ref1;
    return !((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) && "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var MiddleBodyParent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
});
var BannerContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var TopContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var TopLeftSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});
var TopRightSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
var BottomContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
var ButtonContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
var NavContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8(), function(props) {
    var ref, ref1;
    return props.isNavItem ? "1px solid ".concat((0,utils_common/* hexToRgba */.a7)("".concat(props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color), utils_common/* TAB_BAR_OPACITY */.oU) || "#000") : "0px";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.nav) === null || ref1 === void 0 ? void 0 : ref1.color;
});
var NavContent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9());

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_2_Column/ModernMiddleBody3/ModernMiddleBody3.js + 1 modules
var ModernMiddleBody3 = __webpack_require__(86288);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Tabs/ModernMiddleBody2/ModernMiddleBody2.js















function ModernMiddleBody2(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), middleBodyState = ref24[0], setMiddleBodyState = ref24[1];
    var ref25 = (0,react.useState)({
        navLink: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.navContent) === null || ref1 === void 0 ? void 0 : ref1.content) ? (ref3 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.navContent) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.navText : "",
        navContent: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.navContent) === null || ref4 === void 0 ? void 0 : ref4.content) ? (ref6 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.navContent) === null || ref5 === void 0 ? void 0 : ref5.content[0]) === null || ref6 === void 0 ? void 0 : ref6.content : {},
        navId: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.navContent) === null || ref7 === void 0 ? void 0 : ref7.content) ? (ref9 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref8 = middleBodyState.navContent) === null || ref8 === void 0 ? void 0 : ref8.content[0]) === null || ref9 === void 0 ? void 0 : ref9.id : ""
    }), activeLink = ref25[0], setActiveLink = ref25[1];
    var ref26 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref26[0];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref27 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref10 = storeData.theme) === null || ref10 === void 0 ? void 0 : ref10.style_template), propStyle = ref27[0], setPropStyle = ref27[1];
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setMiddleBodyState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref11 = props.config) === null || ref11 === void 0 ? void 0 : ref11.children
    ]);
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.theme) === null || ref12 === void 0 ? void 0 : ref12.style_template
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    var linkRefs = Array.from({
        length: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref13 = middleBodyState.navContent) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : ref14.length
    }).map(function() {
        return /*#__PURE__*/ (0,react.createRef)(null);
    });
    var handleNavClick = function(navText, navContent, index, navId) {
        linkRefs[index].current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
        setActiveLink({
            navLink: navText.length && navContent ? navText : activeLink === null || activeLink === void 0 ? void 0 : activeLink.navLink,
            navContent: navContent ? navContent : activeLink === null || activeLink === void 0 ? void 0 : activeLink.navContent,
            navId: navId ? navId : activeLink === null || activeLink === void 0 ? void 0 : activeLink.navId
        });
    };
    var renderParentContainer = function(bgType) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopLeftSection, {
                            textStyles: propStyle,
                            children: [
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.heading) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    headingData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.heading
                                }),
                                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.description) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                    descriptionData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.description
                                })
                            ]
                        }),
                        (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.button) === null || ref2 === void 0 ? void 0 : ref2.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRightSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                children: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref3 = middleBodyState.button) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.map(function(btnData, idx) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.button) === null || ref === void 0 ? void 0 : ref.type,
                                        btnData: btnData,
                                        primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                        secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                        callback: openForm
                                    }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                                })
                            })
                        })
                    ]
                }),
                (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.navContent) === null || ref5 === void 0 ? void 0 : ref5.content) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContainer, {
                            textStyles: propStyle,
                            isNavItem: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref6 = middleBodyState.navContent) === null || ref6 === void 0 ? void 0 : ref6.content.length) > 0 ? true : false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "nav-links",
                                children: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.navContent) === null || ref7 === void 0 ? void 0 : ref7.content.map(function(navData, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "nav-link-text",
                                        onClick: function() {
                                            return handleNavClick(navData === null || navData === void 0 ? void 0 : navData.navText, navData === null || navData === void 0 ? void 0 : navData.content, idx, navData === null || navData === void 0 ? void 0 : navData.id);
                                        },
                                        ref: linkRefs[idx],
                                        children: [
                                            navData === null || navData === void 0 ? void 0 : navData.navText,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bar ".concat((activeLink === null || activeLink === void 0 ? void 0 : activeLink.navId) === (navData === null || navData === void 0 ? void 0 : navData.id) ? "active" : "hidden")
                                            })
                                        ]
                                    }, navData === null || navData === void 0 ? void 0 : navData.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContent, {
                            children: /*#__PURE__*/ (0,react.createElement)(ModernMiddleBody3["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeLink === null || activeLink === void 0 ? void 0 : activeLink.navContent), {
                                key: activeLink === null || activeLink === void 0 ? void 0 : activeLink.navLink,
                                config: {
                                    children: (ref8 = activeLink.navContent) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.content) === null || ref9 === void 0 ? void 0 : ref9.children
                                }
                            }))
                        })
                    ]
                })
            ]
        });
    };
    return (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref15 = middleBodyState.background) === null || ref15 === void 0 ? void 0 : ref15.type) === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyVideoBackground, {
        id: "MT__MIDDLEBODY1",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody1 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref16 = middleBodyState.media) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.background) === null || ref17 === void 0 ? void 0 : ref17.type),
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                },
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: (ref20 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref18 = middleBodyState.media) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.background) === null || ref19 === void 0 ? void 0 : ref19.content[0]) === null || ref20 === void 0 ? void 0 : ref20.url,
                    type: "video/mp4"
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
                children: [
                    " ",
                    renderParentContainer("video"),
                    " "
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyParent, {
        id: "MT__MIDDLEBODY1",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref21 = middleBodyState.media) === null || ref21 === void 0 ? void 0 : ref21.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody1 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref22 = middleBodyState.media) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.background) === null || ref23 === void 0 ? void 0 : ref23.type),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
            children: [
                " ",
                renderParentContainer("")
            ]
        })
    });
}
/* harmony default export */ var ModernMiddleBody2_ModernMiddleBody2 = (ModernMiddleBody2);


/***/ })

}]);